/**
 * WordPress dependencies
 */
import { registerFormatType } from '@wordpress/rich-text';
/**
 * Internal dependencies
 */

import formats from './default-formats';
formats.forEach(_ref => {
  let {
    name,
    ...settings
  } = _ref;
  return registerFormatType(name, settings);
});
//# sourceMappingURL=index.js.map